import React, { Fragment, memo, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  getCurrentCollectDataStepConfig,
  getCurrentCollectDataStepConfigIndex,
  getCollectDataStepConfigs,
} from 'src/selectors/collectData'
import { SecureWrapper } from 'src/components/layout/SecureWrapper'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { StepItem } from 'src/components/client/home/StepItem'
import { Button } from 'src/components/shared/Button'

interface Props {
  children?: React.ReactNode
}

const CollectDataConfigPageWrapperComponent = ({ children }: Props) => {
  const collectDataStepConfigs = useSelector(getCollectDataStepConfigs)
  const currentCollectDataStepConfig = useSelector(getCurrentCollectDataStepConfig)
  const currentCollectDataStepConfigIndex = useSelector(getCurrentCollectDataStepConfigIndex)

  const [isStarted, setIsStarted] = useState(false)

  const handleStart = useCallback(() => {
    setIsStarted(true)
  }, [])

  if (
    isStarted ||
    !currentCollectDataStepConfig ||
    currentCollectDataStepConfig.collectDataSteps.length <= 1
  ) {
    return <>{children}</>
  }

  return (
    <SecureWrapper>
      <div css={tw`h-full flex w-full flex-col justify-between`}>
        <div css={tw`w-full`}>
          <div
            css={tw`w-11 h-11 flex justify-center items-center [border-radius: 22px] bg-shades-100 mb-4`}
          >
            <div css={tw`bg-black w-5 h-5 rounded-full flex justify-center items-center`}>
              <Typography variant="subtitle2" css={tw`text-shades-0`}>
                {currentCollectDataStepConfigIndex}
              </Typography>
            </div>
          </div>
          <div css={tw`rounded bg-primary-100 px-1 mb-2 w-fit`}>
            <Typography
              variant="overline"
              fontWeight={700}
              css={tw`uppercase text-primary-500`}
            >{`Step ${currentCollectDataStepConfigIndex} of ${collectDataStepConfigs.length}`}</Typography>
          </div>
          <Typography variant="h2">
            {currentCollectDataStepConfig.title || currentCollectDataStepConfig.label}
          </Typography>
          {currentCollectDataStepConfig.description && (
            <Typography css={tw`mt-2 text-shades-400`}>
              {currentCollectDataStepConfig.description}
            </Typography>
          )}
          <div
            css={tw`w-full rounded-lg overflow-hidden border border-solid border-shades-100 mt-4 mb-8 bg-shades-0`}
          >
            {currentCollectDataStepConfig.collectDataSteps.map((item, index) => {
              return (
                <Fragment key={item.id}>
                  <div css={tw`mt-2`} />
                  <StepItem
                    collectDataStep={item}
                    partIndex={index + 1}
                    className={
                      index < currentCollectDataStepConfig.collectDataSteps.length - 1 &&
                      tw`border-0 border-b border-solid border-shades-100`
                    }
                  />
                </Fragment>
              )
            })}
          </div>
        </div>
        <Button className={tw`w-full mt-3`} onClick={handleStart}>
          Start
        </Button>
      </div>
    </SecureWrapper>
  )
}

export const CollectDataConfigPageWrapper = memo(CollectDataConfigPageWrapperComponent)
